
import { carrieMediaArray } from './carrieMedia'
import { aidenReviewerProfile, alexanderReviewerProfile, burgerReviewerProfile, mrBigReviewerProfile } from './carrieReviewers'
import { carrieBio, aidenBio, alexanderBio, burgerBio, mrBigBio } from './carrieBios'
import { carrieDatingProfileHinge, carrieDatingProfileBumble, carrieDatingProfileTinder } from './carrieDatingProfiles'

export const carrieUser = {
  _id: 'carrieUserId',
  email: 'carrie@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...aidenReviewerProfile },
    { ...alexanderReviewerProfile },
    { ...burgerReviewerProfile },
    { ...mrBigReviewerProfile }
  ],
  media: [ ...carrieMediaArray ],
  bio: { ...carrieBio },
  datingProfiles: [
    { ...carrieDatingProfileHinge },
    { ...carrieDatingProfileBumble },
    { ...carrieDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const aidenUser = {
  _id: 'aidenUserId',
  email: 'aiden@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...aidenBio },
  datingProfiles: [],
  reviewerProfile: { ...aidenReviewerProfile },
}

export const alexanderUser = {
  _id: 'alexanderUserId',
  email: 'alexander@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...alexanderBio },
  datingProfiles: [],
  reviewerProfile: { ...alexanderReviewerProfile },
}

export const burgerUser = {
  _id: 'burgerUserId',
  email: 'burger@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...burgerBio },
  datingProfiles: [],
  reviewerProfile: { ...burgerReviewerProfile },
}

export const mrBigUser = {
  _id: 'mrBigUserId',
  email: 'mrbig@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...mrBigBio },
  datingProfiles: [],
  reviewerProfile: { ...mrBigReviewerProfile },
}